import React, { useEffect } from 'react'
import { Icon, l } from '@manychat/manyui'

import { KnowledgeTypesList } from 'apps/aiAutomation/components/KnowledgeTypesList'
import { SidebarHeader } from 'apps/aiAutomation/components/SidebarHeader/SidebarHeader'
import { AiAutomationAnalytics } from 'apps/aiAutomation/lib/analytics'

import cm from './EmptyKnowledge.module.css'

export const EmptyKnowledge = () => {
  useEffect(() => {
    AiAutomationAnalytics.logAutomationEmptyStateOpened({ type: 'instant_answers' })
  }, [])

  return (
    <section className={cm.wrapper}>
      <SidebarHeader />

      <div className={cm.content}>
        <div className={cm.content__description}>
          <Icon.Faq size={32} />

          <h2 className="m-t-sm text-subheading">{l.translate('Set up Always-On Answers')}</h2>

          <p className="m-t-xs">
            {l.translate('Give AI the info it needs to deliver the best answers')}
          </p>
        </div>

        <KnowledgeTypesList />
      </div>
    </section>
  )
}
